import { faMagnifyingGlass, faTv, faStar, faUsers, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import {
    faFacebookF,
    faInstagram,
    faYoutube,
    faTiktok,
    faSnapchat,
    faPinterest,
    faReddit,
} from '@fortawesome/free-brands-svg-icons';

export const defaultAttributionOptions = [
    {
        id: 'facebook_instagram',
        label: 'Facebook/Instagram',
        value: 'Facebook - Instagram',
        icon: faFacebookF,
        iconColor: '#1877F2',
        iconSecondary: faInstagram,
        iconSecondaryColor: '#E4405F',
    },
    {
        id: 'search',
        label: 'Search (Google, Bing, etc.)',
        value: 'Searching Engines',
        icon: faMagnifyingGlass,
        iconColor: '#4285F4',
    },
    {
        id: 'youtube',
        label: 'YouTube',
        value: 'YouTube',
        icon: faYoutube,
        iconColor: '#FF0000',
    },
    {
        id: 'tiktok',
        label: 'TikTok',
        value: 'TikTok',
        icon: faTiktok,
        iconColor: '#000000',
    },
    {
        id: 'streaming_tv',
        label: 'TV or streaming service',
        value: 'TV or Streaming Service',
        icon: faTv,
        iconColor: '#8B4F9F',
    },
    {
        id: 'influencer',
        label: 'Influencer Content',
        value: 'Influencer Content',
        icon: faStar,
        iconColor: '#FFD700',
    },
    {
        id: 'family_friends',
        label: 'Family/Friends',
        value: 'Family - Friends',
        icon: faUsers,
        iconColor: '#00a5b4',
    },
    {
        id: 'review_sites',
        label: 'Review sites (Yelp, etc.)',
        value: 'Review Sites',
        icon: faStar,
        iconColor: '#FF1A1A',
    },
    {
        id: 'pinterest',
        label: 'Pinterest',
        value: 'Pinterest',
        icon: faPinterest,
        iconColor: '#E60023',
    },
    {
        id: 'snapchat',
        label: 'Snapchat',
        value: 'Snapchat',
        icon: faSnapchat,
        iconColor: '#FFD700',
    },
    {
        id: 'reddit',
        label: 'Reddit',
        value: 'Reddit',
        icon: faReddit,
        iconColor: '#FF4500',
    },
    {
        id: 'ai',
        label: 'AI (ChatGPT, Claude, etc.)',
        value: 'AI',
        icon: faWandMagicSparkles,
        iconColor: '#7C3AED',
    },
];

// Fisher-Yates shuffle algorithm
export const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};
